import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'
import ClientPassengerInterface from '../../interfaces/client/Passenger'
import ClientSSRInterface from '../../interfaces/client/SSR'
import NotificationInterface from '../../interfaces/client/Notification'

import { openSpecialSSRModal } from '../../actions/modals'
import { addSpecialSSRModalData } from '../../actions/ssrs'
import {
  addPassengerSSR,
  requestCheckOutPassenger,
} from '../../actions/passengers'
import { removeNotification } from '../../actions/notifications'
import {
  selectPassengerForDeletion,
  deselectPassengerForDeletion,
} from '../../actions/deletePassengers'

import parseFlightId from '../../utils/parseFlightId'
import generateUniqueId from '../../utils/generateUniqueId'
import parentDateOfBirthValidation from '../../utils/forms/parentDateOfBirthValidation'
import { minDifferenceTwoYearsBetweenDates } from '../../utils/validation'
import {
  getFieldNotification,
  getWarningNotifications,
} from '../../utils/notifications'

import EditBookingFormRow from '../../components/EditBookingFormRow'

interface EditBookingFormRowPropsInterface {
  passengerId: string
  isTOFlight: boolean
  rowId: number
  flightId: string
}

export const mapStateToProps = (
  state: ReduxStoreInterface,
  { passengerId, isTOFlight, rowId, flightId }: EditBookingFormRowPropsInterface
) => {
  const passenger: ClientPassengerInterface = state.passengers.byId[passengerId]
  const departureDate = parseFlightId(flightId).date

  const specialSSRNames = state.ssrs.allIds
    .map((ssr: string) => state.ssrs.byId[ssr])
    .filter((ssr: ClientSSRInterface) => ssr.isSpecialSSR)
    .map((ssr: ClientSSRInterface) => ssr.id)

  const passengerErrors =
    state.notifications.passengerIdsToNotificationIds[passengerId]
  const hasErrors = Boolean(passengerErrors)

  const errors: NotificationInterface[] = hasErrors
    ? getWarningNotifications(
        passengerErrors.map(
          (notificationKey: string) => state.notifications.byId[notificationKey]
        )
      )
    : []

  const firstNameError = getFieldNotification(errors, 'FirstName')
  const lastNameError = getFieldNotification(errors, 'LastName')
  const dateOfBirthError = getFieldNotification(errors, 'DateOfBirth')
  const rowError =
    getFieldNotification(errors, 'passengerIds') ||
    getFieldNotification(errors, 'Attributes')

  return {
    rowId,
    passengerId,
    infantId:
      passenger.infant && passenger.infant.id ? passenger.infant.id : '',
    flightId,
    thirdPartyBookingNumber: passenger.thirdPartyBookingNumber || '',
    pnr: passenger.transaviaBookingNumber || '',
    firstName: passenger.firstName,
    lastName: passenger.lastName,
    dateOfBirth: passenger.dateOfBirth,
    gender: passenger.gender,
    luggage: passenger.luggage || '',
    isTravelClassShown: isTOFlight,
    hasInfant: Boolean(passenger.infant),
    travelClass: passenger.travelClass,
    specialSSRNames,
    firstNameError,
    lastNameError,
    dateOfBirthError,
    dateValidator: minDifferenceTwoYearsBetweenDates(departureDate),
    isPassengerSelectedForDeletion: state.passengersToBeDeleted.passengersSelectedForDeletion.includes(
      passengerId
    ),
    isDeletePassengersEnabled: state.deletePassengers.isDeletePassengersEnabled,
    isPassengerCheckedIn: passenger.checkedInOnFlights.includes(flightId),
    rowError,
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  addSSR: (passengerId: string, ssrId: string, specialSSRNames: string[]) => {
    const passengerSSRId = `${ssrId}-${generateUniqueId()}`

    if (specialSSRNames.includes(ssrId)) {
      dispatch(addSpecialSSRModalData(passengerId, ssrId))
      dispatch(openSpecialSSRModal())
      return
    }

    const addPassengerSSROptions = {
      isConfirmed: false,
      isAbleToDelete: true,
    }
    dispatch(
      addPassengerSSR(
        passengerId,
        passengerSSRId,
        ssrId,
        addPassengerSSROptions
      )
    )
  },
  removeNotification: (notificationId: string) => {
    dispatch(removeNotification(notificationId))
  },
  validateDateOfBirth: (
    targetElement: HTMLInputElement,
    passengerId: string,
    validator: Function,
    dateOfBirthError?: NotificationInterface
  ) =>
    parentDateOfBirthValidation(
      targetElement,
      passengerId,
      validator,
      dispatch,
      dateOfBirthError
    ),

  selectPassengerForDeletion: (passengerId: string, infantId: string) => {
    dispatch(selectPassengerForDeletion(passengerId))

    if (infantId) {
      dispatch(selectPassengerForDeletion(infantId))
    }
  },

  deselectPassengerForDeletion: (passengerId: string, infantId: string) => {
    dispatch(deselectPassengerForDeletion(passengerId))

    if (infantId) {
      dispatch(deselectPassengerForDeletion(infantId))
    }
  },
  handleCheckOutPassenger: (data: {
    passengerId: string
    flightId: string
  }) => {
    dispatch(requestCheckOutPassenger(data))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditBookingFormRow)
